<template>
  <div v-loading="loading">
    <el-upload
      ref="resourcesUp"
      action=""
      :accept="accept"
      :auto-upload="autoUpload"
      :http-request="enclosureUpload"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :before-upload="beforeUpload"
      :multiple="multiple"
      :limit="limit"
      :drag="drag"
      :show-file-list="showFileList"
      :file-list="fileList"
    >
      <template>
        <div v-if="drag">
          <i class="el-icon-upload" />
          <div class="el-upload__text">{{ uploadText }}</div>
        </div>
        <div v-else>
          <!-- 选取文件 -->
          <el-button
            slot="trigger"
            size="small" type="primary"
            style="margin-right: 5px"
            icon="el-icon-upload"
          >{{ btnName }}</el-button>
        </div>

        <div slot="tip" class="el-upload__tip">{{ tips }}</div>
      </template>
    </el-upload>
  </div>
</template>

<script>
import { uploadOos } from '@/utils/ali_oos_util';
import i18n from '@/lang/index.js';

export default {
  props: {
    // 回显文件列表
    fileArr: {
      type: Array,
      default: () => []
    },

    // 文件在服务器上的文件夹名称
    serverFolderName: {
      type: String,
      default: 'workOrder'
    },

    // 限制上传文件大小 单位MB
    fileSize: {
      type: Number,
      default: 5
    },

    /**
     * 文件类型 需要传入文件的后缀，而非文件后缀名
     * 如excel 需要传入 ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
     * 可以参考文件 src\enums\evaluateEnums.js
     */
    fileType: {
      type: Array,
      default: () => [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'application/pdf'
      ]
    },

    // 是否自动上传
    autoUpload: {
      type: Boolean,
      default: false
    },

    // 限制上传文件数量
    limit: {
      type: Number,
      default: 1
    },

    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },

    // 是否启用拖拽上传
    drag: {
      type: Boolean,
      default: false
    },

    // 提示文字
    tips: {
      type: String,
      default: ''
    },

    // 上传框内文字提示
    uploadText: {
      type: String,
      default: i18n.t('basicData.DragTheFileHereOrClickUpload')
    },

    // 是否校验文件类型
    isCheckFileType: {
      type: Boolean,
      default: false
    },

    // 是否显示文件列表
    showFileList: {
      type: Boolean,
      default: true
    },

    // 按钮文案
    btnName: {
      type: String,
      default: i18n.t('spareNumberPoo.SelectTheFile')
    }
  },

  data() {
    return {
      fileList: [], // 上传文件列表展示
      loading: false
    };
  },

  computed: {
    // 文件类型
    accept() {
      return this.fileType.length > 0 ? this.fileType.join(',') : '';
    }

  },

  watch: {
    fileArr: {
      handler(newVal) {
        this.fileList = newVal;
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    // 文件上传
    enclosureUpload(option) {
      const file = option.file;
      console.log('上传文件', file);

      if (this.limit === 1) {
        this.fileList = [];
      }

      this.loading = true;
      uploadOos(file, 'workOrder')
        .then(res => {
          if (res.code === 200) {
            // 上传成功：添加文件到列表并通知父组件
            const obj = {
              name: file.name,
              url: res.url,
              uid: file.uid
            };

            this.fileList.push(obj);
            console.log('上传成功', res, obj, this.fileList);

            this.$message.success(`${file.name} ${this.$t('basicData.uploadSuccessful')}`);

            // 需要展示上传文件列表时，回传已上传文件，否则当前上传超过文件
            const fileData = this.showFileList ? this.fileList : [obj];

            this.$emit('change', fileData);
          } else {
            // 上传失败：移除文件并通知父组件
            this.handleUploadFailure(file, res.msg);
          }
        })
        .catch(() => {
          // 异常失败：移除文件并通知父组件
          this.handleUploadFailure(file);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 处理上传失败
    handleUploadFailure(file, msg) {
      this.$message.error(`${file.name} ${msg || this.$t('basicData.uploadFailed')}`);

      this.removeFailedFile(file);

      this.loading = false;

      // this.$emit('change', this.fileList);
    },

    // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 > this.fileSize;
      console.log('文件信息', file, this.fileList);
      // 上传的文件大小不能超过 5MB
      if (fileSize) {
        this.$message.warning(this.$t('basicData.fileSizeExceedsLimit', { size: this.fileSize }));

        // this.$nextTick(() => {
        //   this.removeFailedFile(file);
        // });

        return false;
      }

      // 上传的文件类型限制
      if (this.isCheckFileType) {
        const isBool = this.fileType.includes(file.type);
        if (!isBool) {
          this.$message.warning(this.$t('basicData.invalidFileFormat'));

          // this.$nextTick(() => {
          //   this.removeFailedFile(file);
          // });

          return false;
        }
      }
      return true;
    },

    // 资源上传数量限制
    handleExceed() {
      this.$message.warning(this.$t('basicData.fileSelectionLimit', { size: this.limit }));
    },

    // 删除前提示
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, this.$t('basicData.tips'));
    },

    // 确定删除文件
    handleRemove(file, fileList) {
      const isFailedFile = !file.url && !file.response;

      if (isFailedFile) {
        // 失败文件：只清理 el-upload 内部列表，不通知父组件
        this.removeFailedFile(file);
        return;
      }

      this.fileList = fileList.filter(item => item.url);
      this.$emit('change', this.fileList);
    },

    // 移除上传失败的文件
    removeFailedFile(file) {
      if (!this.$refs.resourcesUp || !file || !file.uid) {
        return;
      }

      // 从 el-upload 组件的文件列表中移除失败的文件
      const uploadFiles = this.$refs.resourcesUp.uploadFiles;
      if (!uploadFiles || !Array.isArray(uploadFiles)) {
        return;
      }

      const index = uploadFiles.findIndex(item => item.uid === file.uid);
      if (index > -1) {
        uploadFiles.splice(index, 1);
      }
    },

    // 清空列表
    clearFiles() {
      this.fileList = [];
      if (this.$refs.resourcesUp) {
        this.$refs.resourcesUp.clearFiles();
      }
    }
  }
};
</script>
